import React, { useEffect } from "react";
import "./TermsConditions.css";

const TermsConditions = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.classList.add("terms-page");

    return () => {
      document.body.classList.remove("terms-page");
    };
  }, []);

  return (
    <div className="terms-conditions">
      {/* Header */}
      <div className="terms-header">
        <div className="container">
          <h1>Terms & Conditions</h1>
          <p className="header-subtitle">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="terms-content">
        <div className="container">
          <div className="terms-card">
            {/* Introduction */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">1</div>
              </div>
              <div className="section-content">
                <h2>Introduction</h2>
                <p>
                  By accessing and using the Kubersetu platform, you agree to be
                  bound by the terms and conditions outlined herein. These terms
                  govern your use of our loan services and associated features.
                </p>
              </div>
            </div>

            {/* Intellectual Property */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">2</div>
              </div>
              <div className="section-content">
                <h2>Intellectual Property</h2>
                <p>
                  All content, trademarks, graphics, designs, and materials on
                  this site are the intellectual property of Kubersetu and are
                  protected by applicable copyright and trademark laws.
                </p>
              </div>
            </div>

            {/* User Responsibilities */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">3</div>
              </div>
              <div className="section-content">
                <h2>User Responsibilities</h2>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your account credentials and agree to accept responsibility
                  for all activities that occur under your account. Misuse or
                  unauthorized use of your account may result in suspension or
                  legal action.
                </p>
              </div>
            </div>

            {/* Limitation of Liability */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">4</div>
              </div>
              <div className="section-content">
                <h2>Limitation of Liability</h2>
                <p>
                  Kubersetu is not liable for any direct or indirect damages
                  arising from the use or inability to use our platform or
                  services, including but not limited to financial loss, data
                  breaches, or technical disruptions.
                </p>
              </div>
            </div>

            {/* Changes to Terms */}
            <div className="policy-section">
              <div className="section-number-wrapper">
                <div className="section-number">5</div>
              </div>
              <div className="section-content">
                <h2>Changes to Terms</h2>
                <p>
                  Kubersetu reserves the right to update or modify these terms
                  at any time without prior notice. Continued use of the
                  platform after such changes signifies your acceptance of the
                  updated terms.
                </p>
              </div>
            </div>
          </div>

          {/* Footer Note */}
          <div className="terms-footer-note">
            <p>
              By using our services, you acknowledge that you have read and
              understood these Terms & Conditions.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
